/**
 * @readonly
 * @enum {string}
 */
export const TelematicDeviceAccessoryTypes = Object.freeze({
    DIGITAL_TACHOGRAPH: 'DIGITAL_TACHOGRAPH',
    FMS: 'FMS',
    LINK_105: 'LINK_105',
    PRO_2020: 'PRO_2020',
    SATELLITE: 'SATELLITE'
})
